import { useTranslation } from 'react-i18next'
import { CURRENCIES, type DisplayCurrency } from '../lib/pricing'
import { useCurrencyStore, useDisplayCurrency } from '../store/currencyStore'

// Currency symbols/codes are universal sector notation — kept as-is (not
// translated) per the i18n jargon rule. TL is listed first (primary market).
const LABELS: Record<DisplayCurrency, string> = {
  TRY: '₺ TL',
  USD: '$ USD',
  EUR: '€ EUR',
}

// Segmented currency selector for the pricing surfaces. Mirrors the cycle
// toggle styling so both controls read as one system.
export default function CurrencyPicker() {
  const { t } = useTranslation()
  const active = useDisplayCurrency()
  const setCurrency = useCurrencyStore((s) => s.setCurrency)

  return (
    <div
      role="group"
      aria-label={t('pricing.currency')}
      className="inline-flex items-center bg-gray-100 rounded-xl p-1"
    >
      {CURRENCIES.map((c) => (
        <button
          key={c}
          onClick={() => setCurrency(c)}
          aria-pressed={active === c}
          className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
            active === c ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          {LABELS[c]}
        </button>
      ))}
    </div>
  )
}
